import {Component, OnInit} from '@angular/core';
import {DoctorService} from 'src/app/services/doctor.service';
import {NgxSpinnerService} from "ngx-spinner";
import {ActivatedRoute, Router} from '@angular/router';
import {isObject} from '@syncfusion/ej2-base';
import {ToastrService} from 'ngx-toastr';

import {NgForm} from '@angular/forms';
import {HomeService} from 'src/app/services/home.service';
import {AuthService} from 'src/app/services/auth.service';

@Component({
  selector: 'app-doctor-list',
  templateUrl: './doctor-list.component.html',
  styleUrls: ['./doctor-list.component.css']
})
export class DoctorListComponent implements OnInit {
  doctorList: any = []
  showfilters: boolean = true
  togglefilter: boolean = false
  filterApplied: boolean = false
  availability: any = [{
    value: 'Today', show: 'Today'
  },
    {value: 'This_week', show: 'This Week'},
    {value: 'Next_Week', show: 'Next Week'},
    {value: 'Next_Month', show: 'Next Month'}
  ]
  availability1: any = ''
  availability2: any = ''
  availability3: any = ''
  availability4: any = ''

  consultation: any = [
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
    'Sunday'
  ]
  consultation1: any = ''
  consultation2: any = ''
  consultation3: any = ''
  consultation4: any = ''
  consultation5: any = ''
  consultation6: any = ''
  consultation7: any = ''

  timing: any = [
    'Morning',
    'Afternoon',
    'Evening'

  ]
  timing1: any = ''
  timing2: any = ''
  timing3: any = ''

  languages = [
    'English',
    'Hindi'
  ]
  language1: any = ''
  language2: any = ''

  gender = [
    'Male',
    'Female'
  ]
  gender1: any = ''
  gender2: any = ''

  rating = ''
  location = ''

  sendAvailability: any = ''
  sendConsultation: any = ''
  sendTiming: any = ''
  sendLang: any = ''
  sendGender: any = ''
  sendRating: any = ''
  sendLocationLat: number = 0
  sendLocationLng: number = 0
  cities: any = []
  object: any = {city: localStorage.getItem('doctorFilterCity') ? localStorage.getItem('doctorFilterCity').toLowerCase() : ''}
  specialities:any=[
    'General Physician',
    'Pediatrician',
    'Gynaecologist',
    'Dentist',
    'Ophthalmologist',
    'Dermatologist',
    'Urologist',
    'ENT(Ear, Nose, Throat)',
    'Dietician',
    'Physiotherapist',
    'Neurologist',
    'Cardiologist',
    'Orthopedist',
    'Homeopath',
    'Ayurveda'

  ]
  currentCity:String=localStorage.getItem('currentcity') ? localStorage.getItem('currentcity').toLowerCase() : ''
  constructor(public doctorSvc: DoctorService, private route: ActivatedRoute,
              public router: Router,
              private spinner: NgxSpinnerService,
              private toaster: ToastrService,
              private homeSvc: HomeService,
              private auth: AuthService) {
  }

  ngOnInit() {
    this.subscribeData();
  //  this.getLocation()

    localStorage.removeItem('doctorFilter')
    this.getCities()
  
  }

  subscribeData() {
    this.route.queryParams.subscribe(data => {
      if(data && data.speciality) {
        this.object['treatment'] = data.speciality;
      }
      this.getDoctor();
    });
  }

  getDoctor() {
    let objectSearch = {
      value: {
        name: this.object['name'],
        city: localStorage.getItem('doctorFilterCity') ? localStorage.getItem('doctorFilterCity') : '',
        treatment: this.object['treatment']
      }
    }
    this.getDoctorsList(objectSearch)
  }

  getLocation() {


    this.auth.getLocation().then(location => {
      console.log(location)
      localStorage.setItem('lat', location.lat)
      localStorage.setItem('lng', location.lng)

      let objectSearch = {
        value: {
          name: '',
          city: localStorage.getItem('doctorFilterCity') ? localStorage.getItem('doctorFilterCity') : '',
          treatment: this.object['treatment']
        }
      }
      this.getDoctorsList(objectSearch)


    })
  }
  clickDetect(form:NgForm){
    this.object.city = localStorage.getItem('currentcity') ? localStorage.getItem('currentcity').toLowerCase():''
    form.value.city = localStorage.getItem('currentcity') ? localStorage.getItem('currentcity').toLowerCase():''
    this.getDoctorsList(form)
  }
  detectLocation(form:NgForm){
    this.object.city = this.currentCity ? this.currentCity.toLowerCase() : ''
    //console.log(this.object)
    // do something with selected item
    form.value.city=this.currentCity ? this.currentCity.toLowerCase() : ''
    console.log(form.value)
    this.getDoctorsList(form)
  }
  selectEvent(item,form:NgForm) {
    console.log(this.currentCity)
  //  console.log(this.object.city)
    this.object.city = item.toLowerCase()
    //console.log(this.object)
    // do something with selected item
    form.value.city=item.toLowerCase()
    console.log(form.value)
    this.getDoctorsList(form)
  }
  selectEvent1(item,form:NgForm) {
    form.value.treatment=item
    this.router.navigate(['/doctors/list'], { queryParams: {speciality: item} });
  }
 
  onChangeSearch(val: string) {
    // fetch remote data from here
    // And reassign the 'data' which is binded to 'data' property.
  }
  
  onFocused(e){
  }

  getCities() {
    this.homeSvc.getCities('DOCTOR').subscribe(res => {
   //  console.log(res["data"] + 'cities')
      this.cities = res["data"]
      if(localStorage.getItem('currentcity')){
       let arr =  this.cities.filter(city=>city.toLowerCase()==localStorage.getItem('currentcity').toLowerCase())
      // console.log(arr)
       if(arr.length==0)
          this.cities.push(localStorage.getItem('currentcity'))
      }
     
       
      
    }, error => {

    })
  }

  isArray(obj: any) {
    return Array.isArray(obj)
  }

  searchDoctorForm(form: NgForm) {
    console.log(form.value)
    this.getDoctorsList(form)
  }
  

  openDoctorDetail(uniqueKey) {
    this.router.navigate(['/doctors/detail/' + uniqueKey])
  }

  getDoctorsList(object) {
    this.spinner.show()
    this.doctorSvc.getDoctorsList(object).subscribe(res => {
        this.doctorList = res["data"];
        this.spinner.hide()
        this.filterApplied = false
        localStorage.removeItem('doctorFilterCity')
      },
      error => {
        console.log(error);
      })
  }

  onCheckAvailability(single, event) {

    if (event.target.checked) {
      this.sendAvailability = single

    } else {
      this.sendAvailability = ''
      this.applyFilter()
    }


  }

  onCheckConsultation(single, event) {
    if (event.target.checked) {
      this.sendConsultation = single

    } else {
      this.sendConsultation = ''
      this.applyFilter()
    }

  }

  onCheckTiming(single, event) {
    if (event.target.checked) {
      this.sendTiming = single
    } else {
      this.sendTiming = ''
      this.applyFilter()
    }


  }

  onCheckLang(single, event) {
    if (event.target.checked) {
      this.sendLang = single
    } else {
      this.sendLang = ''
      this.applyFilter()
    }

  }

  onCheckGender(single, event) {
    if (event.target.checked) {
      this.sendGender = single
    } else {
      this.sendGender = ''
      this.applyFilter()
    }


  }

  clearFilter() {
    this.spinner.show()
    let object = {value: {name: '', city: '', treatment: ''}}
    this.getDoctorsList(object)
    this.availability1 = ''
    this.availability2 = ''
    this.availability3 = ''
    this.availability4 = ''
    this.sendAvailability = ''

    this.consultation1 = ''
    this.consultation2 = ''
    this.consultation3 = ''
    this.consultation4 = ''
    this.consultation5 = ''
    this.consultation6 = ''
    this.consultation7 = ''
    this.sendConsultation = ''

    this.timing1 = ''
    this.timing2 = ''
    this.timing3 = ''
    this.sendTiming = ''

    this.language1 = ''
    this.language2 = ''
    this.sendLang = ''

    this.gender1 = ''
    this.gender2 = ''
    this.sendGender = ''

    this.rating = ''
    this.sendRating = ''

    this.location = ''
    this.sendLocationLat = 0
    this.sendLocationLng = 0


  }

  applyFilter() {
    // console.log(this.sendAvailability)
    // console.log(this.sendConsultation)
    // console.log(this.sendTiming)
    // console.log(this.sendLang)
    // console.log(this.sendGender)
    console.log(this.object)
    this.spinner.show();
    // return false
    // if(this.sendAvailability!='' || this.sendConsultation!='' || this.sendGender!='' || this.sendLang!='' || this.sendTiming!=''){

    this.doctorSvc.applyFilter(this.sendAvailability,
      this.sendConsultation,
      this.sendGender,
      this.sendLang,
      this.sendTiming, 
      this.sendRating,
       this.sendLocationLat, 
       this.sendLocationLng,
       this.object).subscribe(res => {
      this.spinner.hide();
      this.doctorList = res["data"];
      console.log(this.doctorList);
      this.filterApplied = true

      this.doctorList.forEach((o) => {
        o.uniqueKey = o.uniquekey;
      });

      if (!this.togglefilter) {

      } else {
        this.togglefilter = !this.togglefilter
      }
    }, error => {

      this.toaster.error(error.error.message, '', {
        timeOut: 2000
      });
      this.spinner.hide();
    })
    //     }
  }

  locationRating(type, event) {
    console.log(event.target.checked)

    if (type == 'rating') {
 //     this.sendRating = 'Ratings'
      if (!event.target.checked) {
        this.rating = ''
        this.sendRating = ''
      } else {
        this.rating = 'yes'
        this.sendRating = 'Ratings'
      }
    } else {
      if (!event.target.checked) {
        this.location = ''
        this.sendLocationLat = 0
        this.sendLocationLng = 0
      } else {
        this.location = 'yes'
        this.sendLocationLat = Number(localStorage.getItem('lat'))
        this.sendLocationLng = Number(localStorage.getItem('lng'))
      }

    }

  }

  parseInt(number) {
    return parseInt(number)
  }

}
